import { Link } from 'react-router-dom'
import styles from './Footer.module.css'
import SITE from '@/config/site'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={styles.left}>
        <a href={SITE.social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0.5C5.4 0.5 0 5.9 0 12.5C0 17.9 3.4 22.4 8.2 23.9C8.8 24 9 23.6 9 23.3V21.3C5.7 21.9 5 19.5 5 19.5C4.5 18.1 3.7 17.6 3.7 17.6C2.6 16.8 3.8 16.9 3.8 16.9C5 17 5.6 18.2 5.6 18.2C6.7 20 8.5 19.4 9.3 19.1C9.4 18.3 9.8 17.8 10.2 17.5C7.4 17.2 4.5 16.1 4.5 11.4C4.5 10.1 5 9 5.8 8.1C5.6 7.8 5.1 6.6 5.9 5C5.9 5 6.9 4.7 9 6.2C9.9 5.9 10.9 5.8 11.9 5.8C12.9 5.8 14 5.9 14.9 6.2C17 4.7 18 5 18 5C18.8 6.6 18.3 7.8 18.1 8.1C18.9 9 19.4 10.1 19.4 11.4C19.4 16.1 16.5 17.2 13.7 17.5C14.2 17.9 14.6 18.6 14.6 19.7V23.3C14.6 23.6 14.8 24 15.4 23.9C20.2 22.4 23.6 17.9 23.6 12.5C23.6 5.9 18.2 0.5 11.6 0.5H12Z" fill="currentColor"/>
          </svg>
        </a>

        <a href={SITE.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.98 3.5C4.98 4.88 3.87 6 2.49 6C1.11 6 0 4.88 0 3.5C0 2.12 1.11 1 2.49 1C3.87 1 4.98 2.12 4.98 3.5ZM0.5 8H4.5V24H0.5V8ZM8.5 8H12.1V10.4H12.2C12.9 9.1 14.6 7.8 17 7.8C22 7.8 23 11.1 23 16.1V24H19V16.9C19 14.8 18.9 12 16 12C13.1 12 12.6 14.3 12.6 16.7V24H8.6V8H8.5Z" fill="currentColor"/>
          </svg>
        </a>
      </div>

      <div className={styles.center}>
        <Link to={SITE.paths.about} className={styles.aboutLink}>
          {SITE.organization.name}
        </Link>
        <span className={styles.sep}>•</span>
        <span className={styles.copy}>© {year}</span>
      </div>

      <div className={styles.right}>
        <a href={SITE.social.github} target="_blank" rel="noopener noreferrer" className={styles.smallLink}>
          GitHub
        </a>
        <a href={SITE.social.linkedin} target="_blank" rel="noopener noreferrer" className={styles.smallLink}>
          LinkedIn
        </a>
      </div>
    </footer>
  )
}
